/**
 * This is a custom CKEditor 5 build for CreaCheck.
 *
 * AiAssistant integration is documented in
 * @see https://ckeditor.com/docs/ckeditor5/latest/features/ai-assistant/ai-assistant-integration.html#installation
 *
 * Application backend has the API gateway implementation that adds prod key to the request.
 * @see EditionBundle\Controller\ProxyController::proxyAiAssistant method.
 */

import { InlineEditor } from 'ckeditor5';
import plugins from './plugins';
import pluginsCustom from './plugins/custom';
import translations from './translations';
import toolbar from './toolbar';
import 'ckeditor5/ckeditor5.css';
import './hidePoweredBy.css';
import './adjustments.css';

const developmentSettings = {
	licenseKey: 'bis1dExZOXpQNWkxNEQ2Q0lrZUNTc3BTRDhwcVYrUXFOcDVWMGw0Y0k3WnNCWUx2WlB5TTNGUG5wUUFpLU1qQXlNekV5TVRRPQ==',
	ai: {
		openAI: {
				apiUrl: 'https://api.openai.com/v1/chat/completions',
		}
	},
};

const productionSettings = {
	ai: {
		openAI: {
				apiUrl: '/api/aiAssistant.json',
		}
	},
};

const defaultConfig = {
  plugins: [...plugins, ...pluginsCustom],
  translations,
	language: 'de',
	...toolbar,
	list: {
		multiBlock: false, // CC custom override only supports simple lists
	},
  fontColor: {
    // Do not display the color picker.
    colorPicker: false
  },
  fontBackgroundColor: {
    // Do not display the color picker.
    colorPicker: false
  },
	...productionSettings,
	// ...developmentSettings,
};

export default class InlineEditorCC extends InlineEditor {

	static defaultConfig = { ...defaultConfig };

}
